import { gql } from "@apollo/client";
import { TransactionFlowRecordType } from "../types/TransactionFlowRecordType";

export const FIELDS = `
    id
    clientId
    clientName
    transactionType
    transactionTypeDescription
    businessId
    transactionResult
    transactionNo
    currency
    transactionAmount
    transactionTime
    bizOrderNo
`;

export const GET_TRANSACTION_FLOW_RECORD_LISTING = gql`
    query TransactionFlowRecordQuery($filters: TransactionFlowRecordFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getTransactionFlowRecordPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface TransactionFlowRecordListResponse {
    getTransactionFlowRecordPageable: TransactionFlowRecordResponseType;
}

export interface TransactionFlowRecordResponseType {
    content: TransactionFlowRecordType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}




